// @ts-nocheck
import PropTypes from "prop-types";
import React, { useState } from "react";
import className from "./IconSuggest.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";
import { useTranslation } from "react-i18next";

/**
 * @arg {PropTypes.InferProps.<typeof OutputSuggest.propTypes>} props
 * @return {ReturnType.<React.FC>}
 */

export const IconSearchForm = ({ onSearchIcons }) => {
  const { t } = useTranslation();
  // IME入力中flg
  const [compFlg, setCompFlg] = useState(false);

  return (
    <div className={className.searchForm}>
      <span style={{ padding: "8px" }}>
        <img src={getImageUrl("images/icons/search.svg")} width="20" height="20" />
      </span>
      <input
        type="text"
        placeholder={t("IconSearchForm.検索")}
        className={className.searchInput}
        onChange={(e) => {
          if (compFlg) return false;
          onSearchIcons(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();

            return;
          }
        }}
        onCompositionStart={() => {
          setCompFlg(true);
        }}
        onCompositionEnd={(e) => {
          onSearchIcons(e.target.value);
          setCompFlg(false);
        }}
      />
    </div>
  );
};

IconSearchForm.propTypes = {
  onSearchIcons: PropTypes.func,
};
